export type CurrencyResponseBody = {
  code: string;
  name: string;
  symbol: string;
  preferred: boolean;
};
export type GetCurrenciesApiResponse = /** status 200  */ CurrencyResponseBody[];
export type GetCurrenciesApiArg = void;
